// extracted by mini-css-extract-plugin
export default {"container":"NoResults-NoResults-module__container--HWlKW"};